import React from "react";
import { Grid } from "@mui/material";
import FormField from "layouts/pages/account/components/FormField";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SettingsCard from "./SettingsCard";
import {
  FONT_OPTIONS,
  FONT_SIZE_OPTIONS,
  FONT_DROPDOWN_STYLE,
  FONT_SIZE_DROPDOWN_STYLE,
} from "./constants/fontConstants";

const ButtonStylingSection = ({ inputData, autoSaveField }) => {
  const save = (e) => {
    if (autoSaveField) autoSaveField(e.target.name, e.target.value);
  };
  return (
    <SettingsCard
      title="Button Styling"
      subtitle="Configure button colors, fonts, and typography"
      gridProps={{
        xs: 12,
        sx: {
          "@media (min-width: 1100px)": {
            flexBasis: "calc(50% - 12px)",
            maxWidth: "calc(50% - 12px)",
            width: "calc(50% - 12px)",
            marginRight: "24px"
          }
        }
      }}
    >
      <Grid container spacing={2.5}>
        <Grid item xs={4}>
          <FormField
            defaultValue={inputData?.button_bg || "#EF4444"}
            className="color-input"
            label="Background"
            name="button_bg"
            inputProps={{ type: "color" }}
            onBlur={save}
          />
        </Grid>
        <Grid item xs={4}>
          <FormField
            defaultValue={inputData?.button_text || "#ffffff"}
            className="color-input"
            label="Text Color"
            name="button_text"
            inputProps={{ type: "color" }}
            onBlur={save}
          />
        </Grid>
        <Grid item xs={4}>
          <FormField
            defaultValue={inputData?.button_border || "#EF4444"}
            className="color-input"
            label="Border Color"
            name="button_border"
            inputProps={{ type: "color" }}
            onBlur={save}
          />
        </Grid>
        <Grid item xs={12}>
          <SoftBox display="flex" flexDirection="row" gap={2}>
            <SoftBox display="flex" flexDirection="column" flex={1}>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  Button Font
                </SoftTypography>
              </SoftBox>
              <select
                name="button_font"
                defaultValue={inputData?.button_font || "Poppins"}
                style={FONT_DROPDOWN_STYLE}
                onChange={save}
              >
                {FONT_OPTIONS.map((font) => (
                  <option key={font} value={font}>
                    {font}
                  </option>
                ))}
              </select>
            </SoftBox>
            <SoftBox display="flex" flexDirection="column" flex={1}>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  Font Size
                </SoftTypography>
              </SoftBox>
              <select
                name="button_font_size"
                defaultValue={inputData?.button_font_size || "16px"}
                style={FONT_SIZE_DROPDOWN_STYLE}
                onChange={save}
              >
                {FONT_SIZE_OPTIONS.map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </SoftBox>
          </SoftBox>
        </Grid>
      </Grid>
    </SettingsCard>
  );
};


export default ButtonStylingSection;
